import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'opportunity-analytics',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
       dependencies for bundling   */
      // const HomeView = require('./components/HomeView').default;
      const OpportunityAnalytics = require('./containers/OpportunityAnalyticsContainer').default
      /*  Return getComponent   */
      callback(null, OpportunityAnalytics)

      /* Webpack named bundle   */
    }, 'OpportunityAnalyticsView')
  }
})



// WEBPACK FOOTER //
// ./src/routes/OpportunityAnalytics/index.js